import { Menu, MenuDivider, MenuItem } from '../ui/menu'
import { ContextMenu2 } from '@blueprintjs/popover2'
import classNames, { Value as ClassValue } from 'classnames'
import { observer } from 'mobx-react-lite'
import React, { ReactNode } from 'react'
import { TargetAcosProps } from '../TargetACOS'
import { TableStore } from './table_store'

const PinRight = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="15"
        height="14"
        viewBox="0 0 15 17"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M11.5769 8L14.5769 5L11.5769 2V8Z" />
        <path d="M2.1884 8.1115L-9.5525e-05 10.3V11.6H4.6384V16.8L5.2884 17.45L5.9384 16.8V11.6H10.5769V10.3L8.3884 8.1115V1.3H9.5884V0H0.988404V1.3H2.1884V8.1115ZM8.7384 10.3H1.8384L3.4884 8.65V1.3H7.0884V8.65L8.7384 10.3Z" />
    </svg>
)

const PinLeft = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="15"
        height="14"
        viewBox="0 0 15 17"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M3 8L0 5L3 2V8Z" />
        <path d="M12.3885 8.1115L14.577 10.3V11.6H9.9385V16.8L9.2885 17.45L8.6385 16.8V11.6H4V10.3L6.1885 8.1115V1.3H4.9885V0H13.5885V1.3H12.3885V8.1115ZM5.8385 10.3H12.7385L11.0885 8.65V1.3H7.4885V8.65L5.8385 10.3Z" />
    </svg>
)

const UnPin = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M7.58479 15.1667C6.54535 15.1667 5.56472 14.9693 4.64292 14.5746C3.72111 14.1799 2.91431 13.6367 2.2225 12.9452C1.53069 12.2537 0.987292 11.4472 0.592292 10.5258C0.19743 9.60444 0 8.6241 0 7.58479C0 6.53146 0.197361 5.54736 0.592083 4.6325C0.986806 3.71764 1.52993 2.91431 2.22146 2.2225C2.91299 1.53069 3.71944 0.987292 4.64083 0.592292C5.56222 0.19743 6.54257 0 7.58187 0C8.63521 0 9.61931 0.197361 10.5342 0.592083C11.449 0.986805 12.2524 1.52993 12.9442 2.22146C13.636 2.91299 14.1794 3.71597 14.5744 4.63042C14.9692 5.54486 15.1667 6.52868 15.1667 7.58187C15.1667 8.62132 14.9693 9.60194 14.5746 10.5238C14.1799 11.4456 13.6367 12.2524 12.9452 12.9442C12.2537 13.636 11.4507 14.1794 10.5363 14.5744C9.62181 14.9692 8.63799 15.1667 7.58479 15.1667ZM7.58333 14.0833C8.37903 14.0833 9.13194 13.9476 9.84208 13.6763C10.5521 13.4049 11.1928 13.0256 11.7644 12.5385L2.62812 3.40229C2.14632 3.97382 1.7684 4.61458 1.49437 5.32458C1.22035 6.03472 1.08333 6.78764 1.08333 7.58333C1.08333 9.38889 1.71528 10.9236 2.97917 12.1875C4.24306 13.4514 5.77778 14.0833 7.58333 14.0833ZM12.5385 11.7644C13.0256 11.1928 13.4049 10.5521 13.6763 9.84208C13.9476 9.13194 14.0833 8.37903 14.0833 7.58333C14.0833 5.77778 13.4514 4.24306 12.1875 2.97917C10.9236 1.71528 9.38889 1.08333 7.58333 1.08333C6.78569 1.08333 6.03097 1.21771 5.31917 1.48646C4.6075 1.75507 3.96854 2.13563 3.40229 2.62813L12.5385 11.7644Z" />
    </svg>
)

const Hide = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="14"
        height="14"
        viewBox="0 0 21 19"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M14.2345 9.78825L13.1115 8.66525C13.2615 7.83708 13.0253 7.0925 12.4028 6.4315C11.7804 5.77067 11.0167 5.51525 10.1115 5.66525L8.9885 4.54225C9.21417 4.44092 9.44558 4.36492 9.68275 4.31425C9.91992 4.26358 10.1795 4.23825 10.4615 4.23825C11.5962 4.23825 12.5593 4.63408 13.351 5.42575C14.1427 6.21742 14.5385 7.18058 14.5385 8.31525C14.5385 8.59725 14.5132 8.86008 14.4625 9.10375C14.4118 9.34725 14.3358 9.57542 14.2345 9.78825ZM17.4153 12.8997L16.3115 11.8652C16.9448 11.3819 17.5073 10.8527 17.999 10.2778C18.4907 9.70275 18.9115 9.04858 19.2615 8.31525C18.4282 6.63192 17.2323 5.29442 15.674 4.30275C14.1157 3.31108 12.3782 2.81525 10.4615 2.81525C9.97817 2.81525 9.50317 2.84858 9.0365 2.91525C8.56983 2.98192 8.1115 3.08192 7.6615 3.21525L6.49625 2.05C7.12825 1.79867 7.77375 1.61342 8.43275 1.49425C9.09175 1.37492 9.768 1.31525 10.4615 1.31525C12.805 1.31525 14.9184 1.96142 16.8018 3.25375C18.6851 4.54608 20.0588 6.23325 20.923 8.31525C20.5525 9.20875 20.074 10.0427 19.4875 10.8172C18.9008 11.5916 18.2101 12.2858 17.4153 12.8997ZM18.223 18.6845L14.177 14.669C13.6642 14.8588 13.0958 15.014 12.472 15.1345C11.8483 15.255 11.1782 15.3152 10.4615 15.3152C8.1115 15.3152 5.99808 14.6691 4.12125 13.3767C2.24425 12.0844 0.8705 10.3973 0 8.31525C0.369167 7.43192 0.846083 6.60792 1.43075 5.84325C2.01542 5.07842 2.659 4.41525 3.3615 3.85375L0.59225 1.05375L1.64625 0L19.2768 17.6305L18.223 18.6845ZM4.4155 4.9075C3.88717 5.328 3.37333 5.8335 2.874 6.424C2.37467 7.01433 1.9705 7.64475 1.6615 8.31525C2.49483 9.99858 3.69067 11.3361 5.249 12.3278C6.80733 13.3194 8.54483 13.8152 10.4615 13.8152C10.9167 13.8152 11.3699 13.7767 11.8213 13.6997C12.2724 13.6229 12.6551 13.5435 12.9693 13.4615L11.7038 12.1652C11.5333 12.2344 11.3358 12.2895 11.1115 12.3305C10.8872 12.3717 10.6705 12.3922 10.4615 12.3922C9.32683 12.3922 8.36367 11.9964 7.572 11.2047C6.78033 10.4131 6.3845 9.44992 6.3845 8.31525C6.3845 8.11275 6.40508 7.90092 6.44625 7.67975C6.48725 7.45858 6.54233 7.25633 6.6115 7.073L4.4155 4.9075Z" />
    </svg>
)

/** The Hide eye, without the strike through it. */
const Show = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="14"
        height="14"
        viewBox="0 0 21 19"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M10.5 3.5C6.5 3.5 3 6.2 1.5 9.5c1.5 3.3 5 6 9 6s7.5-2.7 9-6c-1.5-3.3-5-6-9-6Zm0 10.1c-2.6 0-4.6-1.8-4.6-4.1s2-4.1 4.6-4.1 4.6 1.8 4.6 4.1-2 4.1-4.6 4.1Zm0-6.6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" />
    </svg>
)

const Down = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="14"
        height="14"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            d="M8.497 3a.75.75 0 1 0-1.5 0v7.723L3.61 7.336a.75.75 0 0 0-1.06 1.061l4.666 4.667a.75.75 0 0 0 1.061 0l4.667-4.667a.75.75 0 1 0-1.061-1.06l-3.386 3.386V3Z"
            clip-rule="evenodd"
        />
    </svg>
)

const Up = ({ className }: { className?: ClassValue }) => (
    <svg
        className={classNames('fill-black', className)}
        width="14"
        height="14"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            d="M8.483 3.172a.75.75 0 0 0-1.466 0L2.72 7.47a.75.75 0 0 0 1.06 1.06L7 5.31v7.357a.75.75 0 0 0 1.5 0V5.31l3.22 3.22a.75.75 0 1 0 1.06-1.061L8.483 3.172Z"
            clip-rule="evenodd"
        />
    </svg>
)

export const HeaderContextMenu = observer(
    <T,>({
        children,
        columnName,
        store,
    }: {
        children: ReactNode
        columnName: string
        store: TableStore<T>
    }) => {
        const handleClick = (v: 'start' | 'end' | false) => (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault()
            e.stopPropagation()
            store.setPinning(columnName, v)
        }

        const currPin = store.isPinned(columnName)

        return (
            <ContextMenu2
                className="w-full"
                content={
                    <Menu>
                        {currPin && (
                            <MenuItem
                                text={
                                    <div className="flex items-center">
                                        <UnPin className="mr-2" /> Unpin
                                    </div>
                                }
                                onClick={handleClick(false)}
                            />
                        )}
                        {currPin !== 'start' && (
                            <MenuItem
                                text={
                                    <div className="flex items-center">
                                        <PinLeft className="mr-2" /> Pin left
                                    </div>
                                }
                                onClick={handleClick('start')}
                            />
                        )}
                        {currPin !== 'end' && (
                            <MenuItem
                                text={
                                    <div className="flex items-center">
                                        <PinRight className="mr-2" /> Pin right
                                    </div>
                                }
                                onClick={handleClick('end')}
                            />
                        )}
                        <MenuDivider />
                        {/* <MenuItem
                            text={
                                <div className="flex items-center">
                                    <Up className="mr-2" /> Sort Ascending
                                </div>
                            }
                            onClick={() => store.setSort(columnName)}
                        />
                        <MenuItem
                            text={
                                <div className="flex items-center">
                                    <Down className="mr-2" /> Sort Descending
                                </div>
                            }
                            onClick={() => store.setSort(`-${columnName}`)}
                        />
                        <MenuDivider /> */}
                        <MenuItem
                            text={
                                <div className="flex items-center">
                                    <Hide className="mr-2" /> Hide
                                </div>
                            }
                            onClick={() => store.toggleVisible(columnName)}
                        />
                        {/*
                         * The reverse of Hide belongs next to it. A user who
                         * hid a column from this menu looks here first, not in
                         * the toolbar. Always rendered, disabled when there is
                         * nothing to reveal, so it reads as an available
                         * action rather than appearing only once it is needed.
                         */}
                        <MenuItem
                            text={
                                <div className="flex items-center">
                                    <Show className="mr-2" /> Restore hidden columns
                                </div>
                            }
                            disabled={!store.canRestoreColumns}
                            onClick={() => store.restoreHiddenColumns()}
                        />
                    </Menu>
                }
            >
                {children}
            </ContextMenu2>
        )
    },
)

export function isTargetAcosProps<
    Tar extends 'campaign' | 'ad_group' | 'targets' | 'keywords' | 'portfolio',
>(obj: Omit<TargetAcosProps, 'target'>, target: Tar): obj is TargetAcosProps {
    return (
        'target_acos' in obj &&
        'default_target_acos' in obj &&
        'target_acos_parent_type_id' in obj &&
        'target_acos_parent_id' in obj &&
        (target === 'campaign'
            ? 'campaign_id' in obj
            : target === 'ad_group'
              ? 'ad_group_id' in obj && 'campaign_id' in obj
              : target === 'targets'
                ? 'target_id' in obj && 'ad_group_id' in obj && 'campaign_id' in obj
                : target === 'keywords'
                  ? 'keyword_id' in obj && 'ad_group_id' in obj && 'campaign_id' in obj
                  : target === 'portfolio'
                    ? 'id' in obj
                    : false)
    )
}
